var _Tone$dark, _Tone$light, _Object$freeze;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { Palette, Tone, Appearance } from "./Chip.types";
export var getAppearance = function getAppearance(tone, palette, appearance) {
  if (appearance === Appearance.solid) {
    return Colors[tone][palette];
  } else {
    return _objectSpread(_objectSpread({}, Colors[tone][palette]), {}, {
      backgroundColor: 'white',
      borderWidth: '2px',
      borderStyle: 'solid',
      color: 'grey.900',
      iconColor: 'grey.900',
      iconMouseOverColor: 'grey.900'
    });
  }
};
export var Colors = Object.freeze((_Object$freeze = {}, _defineProperty(_Object$freeze, Tone.dark, (_Tone$dark = {}, _defineProperty(_Tone$dark, Palette.primary, {
  backgroundColor: 'blue.500',
  borderColor: 'blue.500',
  color: 'white'
}), _defineProperty(_Tone$dark, Palette.neutral, {
  backgroundColor: 'grey.700',
  borderColor: 'grey.700',
  color: 'grey.200'
}), _defineProperty(_Tone$dark, Palette.info, {
  backgroundColor: 'yellow.500',
  borderColor: 'yellow.500',
  color: 'white'
}), _defineProperty(_Tone$dark, Palette.danger, {
  backgroundColor: 'red.500',
  borderColor: 'red.500',
  color: 'white'
}), _defineProperty(_Tone$dark, Palette.success, {
  backgroundColor: 'green.500',
  borderColor: 'green.500',
  color: 'white'
}), _defineProperty(_Tone$dark, Palette.white, {
  backgroundColor: 'grey.900',
  borderColor: 'grey.900',
  color: 'white'
}), _Tone$dark)), _defineProperty(_Object$freeze, Tone.light, (_Tone$light = {}, _defineProperty(_Tone$light, Palette.primary, {
  backgroundColor: 'blue.100',
  borderColor: 'blue.100',
  color: 'grey.900',
  iconColor: 'blue.600',
  iconMouseOverColor: 'blue.400'
}), _defineProperty(_Tone$light, Palette.neutral, {
  backgroundColor: 'grey.200',
  borderColor: 'grey.200',
  color: 'grey.900',
  iconColor: 'grey.400',
  iconMouseOverColor: 'grey.300'
}), _defineProperty(_Tone$light, Palette.info, {
  backgroundColor: 'yellow.100',
  borderColor: 'yellow.100',
  color: 'grey.900',
  iconColor: 'yellow.600',
  iconMouseOverColor: 'yellow.400'
}), _defineProperty(_Tone$light, Palette.danger, {
  backgroundColor: 'red.100',
  borderColor: 'red.100',
  color: 'grey.900',
  iconColor: 'red.600',
  iconMouseOverColor: 'red.400'
}), _defineProperty(_Tone$light, Palette.success, {
  backgroundColor: 'green.100',
  borderColor: 'green.100',
  color: 'grey.900',
  iconColor: 'green.600',
  iconMouseOverColor: 'green.400'
}), _defineProperty(_Tone$light, Palette.white, {
  backgroundColor: 'white',
  borderColor: 'grey.900',
  color: 'grey.900',
  iconColor: 'grey.900',
  iconMouseOverColor: 'grey.700'
}), _Tone$light)), _Object$freeze));